
import React from 'react';

export default class Header extends React.Component {
    render() {
        return (
            <h2 style={this.props.style}>{this.props.title}</h2>
        );
    }
}